<template>
  <div class="user-management-container">
    <div class="page-header">
      <h2>用户管理</h2>
      <div class="header-buttons">
        <!-- <el-button type="success" @click="showBatchImportDialog">
          <el-icon><Upload /></el-icon> 批量导入
        </el-button> -->
        <!-- <el-button type="info" @click="exportUsers">
          <el-icon><Download /></el-icon> 导出用户
        </el-button> -->
        <el-button type="primary" @click="showAddUserDialog">
          <el-icon><Plus /></el-icon> 添加用户
        </el-button>
        <el-button type="primary" @click="generateVipCodeDialog">
          <el-icon><Plus /></el-icon> 生成会员码
        </el-button>
      </div>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-bar">
      <div class="search-filter-container">
        <!-- 搜索框 -->
        <el-input
          v-model="searchQuery"
          placeholder="搜索用户名/手机号/昵称"
          clearable
          @clear="handleSearchClear"
          @input="handleSearchInput"
          @keyup.enter="fetchUsers"
          style="width: 300px; margin-right: 15px;"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
          <template #append>
            <el-button @click="fetchUsers">搜索</el-button>
          </template>
        </el-input>
        
        <!-- 状态筛选 -->
        <el-select 
          v-model="statusFilter" 
          placeholder="账号状态" 
          clearable
          @change="handleStatusFilterChange"
          style="width: 120px;"
        >
          <el-option label="全部账号" value="" />
          <el-option label="启用账号" value="active" />
          <el-option label="禁用账号" value="inactive" />
        </el-select>
      </div>
    </div>
    
    <!-- 用户列表 -->
    <el-table
      v-loading="loading"
      :data="users"
      border
      style="width: 100%"
      row-key="id"
      empty-text="暂无用户数据"
    >
      <el-table-column label="ID" prop="id" width="80" sortable />
      <el-table-column label="用户名" prop="username" width="180" />
      <el-table-column label="角色" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.role === 'admin' ? 'danger' : 'info'">
            {{ scope.row.role === 'admin' ? '管理员' : '普通用户' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="账号状态" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.is_active ? 'success' : 'danger'">
            {{ scope.row.is_active ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
       <el-table-column label="会员状态" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.vip_level > 0 ? 'success' : 'danger'">
            {{ scope.row.vip_level > 0 ? '会员' : '非会员' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="注册时间" prop="created_at" width="180" sortable>
        <template #default="scope">
          {{ formatDate(scope.row.created_at) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="420">
        <template #default="scope">
          <div v-if="scope.row.role === 'admin'" class="admin-operation-notice">
            <el-tag type="warning">管理员账号不可操作</el-tag>
          </div>
          <div v-else class="operation-buttons">
            <el-button 
              size="small" 
              :type="scope.row.is_active ? 'danger' : 'success'" 
              @click="toggleUserStatus(scope.row)"
            >
              {{ scope.row.is_active ? '禁用' : '启用' }}
            </el-button>
            <el-button 
              size="small" 
              type="warning" 
              @click="showResetPasswordDialog(scope.row)"
              :icon="Key"
            >
              重置密码
            </el-button>
            <el-button 
              size="small" 
              type="danger" 
              @click="confirmDeleteUser(scope.row)"
              :icon="Delete"
            >
              删除
            </el-button>
            <el-button 
              size="small" 
              type="info" 
              @click="viewLoginHistory(scope.row)"
              :icon="View"
            >
              登录历史
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
      />
    </div>
    
    <!-- 添加用户对话框 -->
    <el-dialog
      v-model="addUserDialogVisible"
      title="添加用户"
      width="500px"
      destroy-on-close
    >
      <el-form
        ref="addUserFormRef"
        :model="addUserForm"
        :rules="addUserRules"
        label-width="100px"
        status-icon
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="addUserForm.username" placeholder="请输入用户名" />
          <small class="form-tip">用户名将用于登录，3-20个字符</small>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="addUserForm.password"
            type="password"
            placeholder="请输入密码"
            show-password
          />
          <small class="form-tip">密码长度至少8位，且需包含数字、字母、符号中的至少两种组合</small>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="addUserForm.confirmPassword"
            type="password"
            placeholder="请确认密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="addUserDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAddUser" :loading="submitting">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 生成会员码弹框 -->
    <el-dialog
      v-model="generateVipCodeVisible"
      title="添加用户"
      width="500px"
      destroy-on-close
    >
      <el-form
        ref="generateVipCodeFormRef"
        :model="generateVipCodeForm"
        label-width="100px"
        status-icon
      >
        <el-form-item label="生成数量" prop="num">
          <el-input v-model="generateVipCodeForm.num" placeholder="请输入生成数量" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="generateVipCodeVisible = false">取消</el-button>
          <el-button type="primary" @click="submitgenerateVipCode" :loading="submitting">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>

     <!-- 展示会员码弹框 -->
    <el-dialog
      v-model="vipCodeVisible"
      title="会员码"
      width="500px"
      destroy-on-close
    >
      <el-button type="primary" @click="copyVipCodeList()">
        <el-icon></el-icon> 全部复制<CopyDocument />
      </el-button>
      <el-table :data="vipCodeList" style="width: 100%">
        <el-table-column prop="code" label="会员码" width="250" />
        <el-table-column label="操作" fixed="right" width="100">
          <template #default="scope">
            <div>
              <el-button 
                size="small" 
                type="primary" 
                @click="copyVipCode(scope.row)"
                :icon="CopyDocument"
              >
                复制
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    
    <!-- 重置密码对话框 -->
    <el-dialog
      v-model="resetPasswordDialogVisible"
      title="重置密码"
      width="500px"
      destroy-on-close
    >
      <el-form
        ref="resetPasswordFormRef"
        :model="resetPasswordForm"
        :rules="resetPasswordRules"
        label-width="100px"
        status-icon
      >
        <p class="user-info">
          用户: <strong>{{ selectedUser?.username }}</strong>
        </p>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="resetPasswordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          />
          <small class="form-tip">密码长度至少6位</small>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="resetPasswordForm.confirmPassword"
            type="password"
            placeholder="请确认密码"
            show-password
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="resetPasswordDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitResetPassword" :loading="submitting">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
    
    <!-- 用户详情对话框 -->
    <el-dialog
      v-model="userDetailsDialogVisible"
      title="用户详情"
      width="800px"
      top="5vh"
      class="user-details-dialog"
    >
      <div v-if="userDetails" class="user-details">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="用户ID">{{ userDetails.user.id }}</el-descriptions-item>
          <el-descriptions-item label="用户名">{{ userDetails.user.username }}</el-descriptions-item>
          <el-descriptions-item label="角色">{{ userDetails.user.role }}</el-descriptions-item>
          <el-descriptions-item label="注册时间">{{ formatDate(userDetails.user.created_at) }}</el-descriptions-item>
        </el-descriptions>
        
        <!-- 用户头像 -->
        <div class="user-avatar-section" v-if="userDetails.user.avatar">
          <h3>用户头像</h3>
          <el-image
            :src="userDetails.user.avatar"
            style="width: 120px; height: 120px"
            fit="cover"
          >
            <template #error>
              <div class="no-avatar">
                <el-icon><UserFilled /></el-icon>
              </div>
            </template>
          </el-image>
        </div>
        
        <!-- 素材需求统计 -->
        <div class="stats-section">
          <h3>素材需求统计</h3>
          <el-descriptions v-if="userDetails.requirements.total > 0" :column="5" border>
            <el-descriptions-item label="总数量">{{ userDetails.requirements.total }}</el-descriptions-item>
            <template v-for="(count, status) in formatRequirementStatuses(userDetails.requirements.statuses)" :key="status">
              <el-descriptions-item :label="status">{{ count }}</el-descriptions-item>
            </template>
          </el-descriptions>
          <el-empty v-else description="暂无素材需求数据" />
        </div>
        
        <!-- 私人定制统计 -->
        <div class="stats-section">
          <h3>私人定制统计</h3>
          <el-descriptions v-if="userDetails.customs.total > 0" :column="5" border>
            <el-descriptions-item label="总数量">{{ userDetails.customs.total }}</el-descriptions-item>
            <template v-for="(count, status) in formatCustomStatuses(userDetails.customs.statuses)" :key="status">
              <el-descriptions-item :label="status">{{ count }}</el-descriptions-item>
            </template>
          </el-descriptions>
          <el-empty v-else description="暂无私人定制数据" />
        </div>
        
        <!-- 平台账号 -->
        <div class="platform-section">
          <h3>平台账号 ({{ userDetails.platforms.length }})</h3>
          <el-empty v-if="userDetails.platforms.length === 0" description="未添加平台账号" />
          <div v-else class="platform-cards">
            <el-card v-for="platform in userDetails.platforms" :key="platform.id" class="platform-card">
              <template #header>
                <div class="platform-header">
                  <img :src="getPlatformIcon(platform.platform)" alt="平台图标" class="platform-icon">
                  <span>{{ getPlatformName(platform.platform) }}</span>
                </div>
              </template>
              <el-descriptions :column="1" size="small" border>
                <el-descriptions-item label="账号名称">{{ platform.account_name }}</el-descriptions-item>
                <el-descriptions-item label="账号ID">{{ platform.account_id }}</el-descriptions-item>
                <el-descriptions-item label="主页链接">
                  <el-link :href="platform.homepage_url" target="_blank" type="primary">{{ platform.homepage_url }}</el-link>
                </el-descriptions-item>
                <el-descriptions-item label="添加时间">{{ formatDate(platform.created_at) }}</el-descriptions-item>
              </el-descriptions>
            </el-card>
          </div>
        </div>
      </div>
      <div v-else class="loading-details">
        <el-skeleton :rows="10" animated />
      </div>
    </el-dialog>

    <!-- 登录历史对话框 -->
    <UserLoginHistory
      v-model="loginHistoryDialogVisible"
      :userId="selectedUserId"
    />

    <!-- 批量导入用户对话框 -->
    <el-dialog
      v-model="batchImportDialogVisible"
      title="批量导入用户"
      width="600px"
      destroy-on-close
    >
      <el-tabs v-model="importTabActive">
        <el-tab-pane label="手动输入" name="manual">
          <div class="import-instructions">
            <p>请按以下格式填写用户名，每行一个用户名：</p>
            <p class="form-tip">所有导入用户的初始密码均为：666666</p>
          </div>
          <el-input
            v-model="batchUsernames"
            type="textarea"
            :rows="10"
            placeholder="用户名1&#10;用户名2&#10;用户名3"
            class="batch-import-textarea"
          />
          <div class="import-example">
            <p class="form-tip">也可以下载Excel模板，填写后复制内容到此处</p>
            <el-button type="text" @click="downloadTemplate">
              <el-icon><Document /></el-icon> 下载Excel模板
            </el-button>
          </div>
        </el-tab-pane>
        
        <el-tab-pane label="上传Excel" name="excel">
          <div class="import-instructions">
            <p>请上传Excel文件(.xlsx, .xls, .csv)：</p>
            <p class="form-tip">所有导入用户的初始密码均为：666666</p>
            <p class="form-tip">Excel文件第一列应为用户名，系统将从第2行开始读取用户名</p>
          </div>
          
          <el-upload
            class="excel-uploader"
            :auto-upload="false"
            :limit="1"
            accept=".xlsx,.xls,.csv"
            :on-change="handleExcelChange"
            :on-remove="handleExcelRemove"
            :file-list="excelFileList"
          >
            <el-button type="primary">
              <el-icon><Upload /></el-icon> 选择Excel文件
            </el-button>
            <template #tip>
              <div class="el-upload__tip">
                支持 .xlsx, .xls, .csv 格式文件
              </div>
            </template>
          </el-upload>
          
          <div v-if="previewData.length > 0" class="excel-preview-container">
            <h4>用户名预览 (最多显示10条)：</h4>
            <el-table :data="previewData" border style="width: 100%">
              <el-table-column prop="username" label="用户名" />
            </el-table>
            <p class="preview-count">共读取到 {{ totalExcelRows }} 条用户名</p>
          </div>
          
          <div class="template-download">
            <p class="form-tip">没有模板？</p>
            <el-button type="text" @click="downloadTemplate">
              <el-icon><Document /></el-icon> 下载Excel模板
            </el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="batchImportDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleBatchImport" :loading="importLoading">
            确定导入
          </el-button>
        </span>
      </template>
    </el-dialog>
    
    <!-- 导入结果对话框 -->
    <el-dialog
      v-model="importResultDialogVisible"
      title="导入结果"
      width="600px"
    >
      <div class="import-result">
        <div class="result-summary">
          <el-row>
            <el-col :span="24">
              <el-statistic title="总计尝试导入" :value="importResult.total" />
            </el-col>
          </el-row>
          <el-row :gutter="20" class="statistic-row">
            <el-col :span="12">
              <el-statistic title="成功导入" :value="importResult.success" value-style="color: #67C23A" />
            </el-col>
            <el-col :span="12">
              <el-statistic title="失败" :value="importResult.failed" value-style="color: #F56C6C" />
            </el-col>
          </el-row>
        </div>
        
        <div v-if="importResult.failedDetails.length > 0" class="failed-details">
          <h4>失败详情:</h4>
          <el-table :data="importResult.failedDetails" border stripe>
            <el-table-column prop="username" label="用户名" width="180" />
            <el-table-column prop="reason" label="失败原因" />
          </el-table>
        </div>
      </div>
      
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="importResultDialogVisible = false">
            关闭
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Search, UserFilled, Key, Delete, Plus, View, Upload, Download, Document,CopyDocument } from '@element-plus/icons-vue';
import request from '@/utils/request';
import requestV2 from '@/utils/requestV2';

import UserLoginHistory from '@/components/admin/UserLoginHistory.vue';
import * as XLSX from 'xlsx';

// 用户列表数据
const users = ref([]);
const loading = ref(false);
const currentPage = ref(1);
const pageSize = ref(10);
const total = ref(0);
const searchQuery = ref('');
const searchTimer = ref(null); // 搜索防抖定时器
const statusFilter = ref(''); // 状态筛选（'active', 'inactive', 或 ''表示全部）

// 添加用户相关
const addUserDialogVisible = ref(false);
const addUserFormRef = ref(null);
const addUserForm = reactive({
  username: '',
  password: '',
  confirmPassword: ''
});


// 添加会员码相关
const generateVipCodeForm = reactive({
  num: ''
});
const generateVipCodeFormRef = ref(null);
// 生成会员码弹框开关
const generateVipCodeVisible = ref(false);
// 生成的会员码列表弹框开关
const vipCodeVisible = ref(false);
// 生成的会员码列表
const vipCodeList = ref([]);


// 添加用户表单验证规则
const addUserRules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 3, max: 20, message: '用户名长度应为3-20个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少为6个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== addUserForm.password) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ]
};

// 重置密码相关
const resetPasswordDialogVisible = ref(false);
const resetPasswordFormRef = ref(null);
const resetPasswordForm = reactive({
  newPassword: '',
  confirmPassword: ''
});
const selectedUser = ref(null);

// 重置密码表单验证规则
const validatePasswordStrength = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'));
      }
      // 密码长度至少8位
      if (value.length < 8) {
        return callback(new Error('密码长度至少8位'));
      }
      // 检查字符类型
      const hasNumber = /\d/.test(value);
      const hasLetter = /[a-zA-Z]/.test(value);
      const hasSymbol = /[^a-zA-Z0-9]/.test(value);
      const typeCount = [hasNumber, hasLetter, hasSymbol].filter(Boolean).length;
      
      if (typeCount < 2) {
        return callback(new Error('密码需包含数字、字母、符号中的至少两种组合'));
      }
      callback();
    };

    const resetPasswordRules = {
  newPassword: [
      { required: true, validator: validatePasswordStrength, trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    {
      validator: (rule, value, callback) => {
        if (value !== resetPasswordForm.newPassword) {
          callback(new Error('两次输入的密码不一致'));
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ]
};

// 用户详情相关
const userDetailsDialogVisible = ref(false);
const userDetails = ref(null);

// 提交状态
const submitting = ref(false);
const generateVipCodeSubmitting = ref(false);

// 登录历史相关
const loginHistoryDialogVisible = ref(false);
const selectedUserId = ref(null);

// 批量导入相关
const batchImportDialogVisible = ref(false);
const batchUsernames = ref('');
const importLoading = ref(false);
const importResultDialogVisible = ref(false);
const importResult = ref({
  total: 0,
  success: 0,
  failed: 0,
  failedDetails: []
});
const importTabActive = ref('manual');
const excelFileList = ref([]);
const parsedExcelData = ref([]);
const previewData = computed(() => {
  if (parsedExcelData.value.length === 0) return [];
  return parsedExcelData.value.slice(0, 10).map(username => ({ username }));
});
const totalExcelRows = computed(() => parsedExcelData.value.length);

// 生命周期钩子
onMounted(() => {
  fetchUsers();
});

// 搜索相关方法
const handleSearchInput = () => {
  // 使用防抖，500ms内只触发一次搜索
  if (searchTimer.value) {
    clearTimeout(searchTimer.value);
  }
  searchTimer.value = setTimeout(() => {
    fetchUsers();
  }, 500);
};

const handleSearchClear = () => {
  fetchUsers();
};

// 状态筛选变化
const handleStatusFilterChange = () => {
  fetchUsers();
};


const copyVipCode = async (row) => {
  try {
    await navigator.clipboard.writeText(row.code);
    ElMessage.success('会员码复制成功');
  } catch (error) {
    ElMessage.error('复制失败，请手动复制');
    console.error('复制失败:', error);
  }
};

const copyVipCodeList = async () => {
  if (!vipCodeList.value.length) {
    ElMessage.warning('没有会员码可复制');
    return;
  }
  
  try {
    // 提取所有会员码，用换行符分隔
    const allCodes = vipCodeList.value.map(item => item.code).join('\n');
    await navigator.clipboard.writeText(allCodes);
    ElMessage.success(`成功复制 ${vipCodeList.value.length} 个会员码`);
  } catch (error) {
    ElMessage.error('批量复制失败，请手动复制');
    console.error('批量复制失败:', error);
  }
};

// 获取用户列表
const fetchUsers = async () => {
  loading.value = true;
  try {
    const response = await requestV2.get('/system/users/manage', {
      params: {
        page: currentPage.value,
        pageSize: pageSize.value,
        search: searchQuery.value,
        status: statusFilter.value || undefined // 如果为空字符串，传undefined表示不筛选
      }
    });
    users.value = response.data.data.records || [];
    total.value = response.data.data.total || 0;
    
    // 清空搜索防抖定时器
    if (searchTimer.value) {
      clearTimeout(searchTimer.value);
      searchTimer.value = null;
    }
  } catch (error) {
    console.error('获取用户列表失败:', error);
    ElMessage.error('获取用户列表失败');
  } finally {
    loading.value = false;
  }
};

// 分页处理
const handleSizeChange = (size) => {
  pageSize.value = size;
  fetchUsers();
};

const handleCurrentChange = (page) => {
  currentPage.value = page;
  fetchUsers();
};

// 添加用户相关函数
const showAddUserDialog = () => {
  addUserForm.username = '';
  addUserForm.password = '';
  addUserForm.confirmPassword = '';
  addUserDialogVisible.value = true;
  // 在下一个tick中重置表单校验结果
  setTimeout(() => {
    if (addUserFormRef.value) {
      addUserFormRef.value.resetFields();
    }
  }, 0);
};

// 生成会员码
const generateVipCodeDialog = () => {
  generateVipCodeVisible.value = true;
};

const submitgenerateVipCode = async () => {
  if (!generateVipCodeFormRef.value) return;
  await generateVipCodeFormRef.value.validate(async (valid) => {
    if (valid) {
      generateVipCodeSubmitting.value = true;
      try {
        const response = await requestV2.post('/vip-code/generate', {
          num: generateVipCodeForm.num,
        });
        console.log("生成会员码",response.data.code)
        if(response.data.code == 200){
          vipCodeList.value = response.data.data.codes;
          ElMessage.success('生成会员码成功');
          generateVipCodeVisible.value = false;
          //打开会员码列表弹框
          vipCodeVisible.value = true;
        }else{
          ElMessage.error('生成会员码失败');
          generateVipCodeVisible.value = false;
        }
      } catch (error) {
        console.error('生成会员码失败:', error);
        ElMessage.error(error.response?.data?.message || '生成会员码失败');
      } finally {
        generateVipCodeSubmitting.value = false;
      }
    }
  });
};

const submitAddUser = async () => {
  if (!addUserFormRef.value) return;

  await addUserFormRef.value.validate(async (valid) => {
    if (valid) {
      submitting.value = true;
      try {
        const response = await requestV2.post('/system/users/manage', {

          username: addUserForm.username,
          password: addUserForm.password
        });

        ElMessage.success('用户添加成功');
        addUserDialogVisible.value = false;
        fetchUsers();
      } catch (error) {
        console.error('添加用户失败:', error);
        ElMessage.error(error.response?.data?.message || '添加用户失败');
      } finally {
        submitting.value = false;
      }
    }
  });
};

// 重置密码相关函数
const showResetPasswordDialog = (user) => {
  selectedUser.value = user;
  resetPasswordForm.newPassword = '';
  resetPasswordForm.confirmPassword = '';
  resetPasswordDialogVisible.value = true;
  // 在下一个tick中重置表单校验结果
  setTimeout(() => {
    if (resetPasswordFormRef.value) {
      resetPasswordFormRef.value.resetFields();
    }
  }, 0);
};

const submitResetPassword = async () => {
  if (!resetPasswordFormRef.value) return;
  
  await resetPasswordFormRef.value.validate(async (valid) => {
    if (valid) {
      submitting.value = true;
      try {
        const response = await requestV2.post(`/system/users/manage/${selectedUser.value.id}/reset-password`, {
          new_password: resetPasswordForm.newPassword
        });
        
        ElMessage.success('密码重置成功');
        resetPasswordDialogVisible.value = false;
      } catch (error) {
        console.error('重置密码失败:', error);
        ElMessage.error(error.response?.data?.message || '重置密码失败');
      } finally {
        submitting.value = false;
      }
    }
  });
};

// 删除用户
const confirmDeleteUser = (user) => {
  ElMessageBox.confirm(
    `确定要删除用户 "${user.username}" 吗？此操作不可恢复，并且会删除该用户的所有相关数据。`,
    '确认删除',
    {
      confirmButtonText: '确定删除',
      cancelButtonText: '取消',
      type: 'warning',
      distinguishCancelAndClose: true,
      confirmButtonClass: 'el-button--danger'
    }
  )
    .then(async () => {
      loading.value = true;
      try {
        await requestV2.delete(`/system/users/manage/${user.id}`);
        ElMessage.success('用户删除成功');
        fetchUsers();
      } catch (error) {
        console.error('删除用户失败:', error);
        ElMessage.error(error.response?.data?.message || '删除用户失败');
      } finally {
        loading.value = false;
      }
    })
    .catch(() => {
      // 用户取消删除操作
    });
};

// 查看用户详情
const viewUserDetails = async (user) => {
  userDetails.value = null;
  userDetailsDialogVisible.value = true;
  
  try {
    const response = await request.get(`/users/manage/${user.id}`);
    userDetails.value = response.data;
  } catch (error) {
    console.error('获取用户详情失败:', error);
    ElMessage.error('获取用户详情失败');
    userDetailsDialogVisible.value = false;
  }
};

// 格式化日期
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  });
};

// 格式化需求状态显示 - 由于后端已经返回中文状态，不需要再转换
const formatRequirementStatuses = (statuses) => {
  return statuses || {};
};

// 格式化定制状态显示 - 由于后端已经返回中文状态，不需要再转换
const formatCustomStatuses = (statuses) => {
  return statuses || {};
};

// 获取平台图标和名称
const getPlatformIcon = (platform) => {
  const icons = {
    'douyin': '/images/platforms/douyin.png',
    'kuaishou': '/images/platforms/kuaishou.png',
    'bilibili': '/images/platforms/bilibili.png'
  };
  
  return icons[platform.toLowerCase()] || '/images/platforms/default.png';
};

const getPlatformName = (platform) => {
  const names = {
    'douyin': '抖音',
    'kuaishou': '快手',
    'bilibili': 'B站'
  };
  
  return names[platform.toLowerCase()] || platform;
};

// 切换用户状态
const toggleUserStatus = async (user) => {
  const newStatus = !user.is_active;
  const statusText = newStatus ? '启用' : '禁用';
  
  try {
    ElMessageBox.confirm(
      `确定要${statusText}用户 "${user.username}" 吗？`,
      `确认${statusText}`,
      {
        confirmButtonText: `确定${statusText}`,
        cancelButtonText: '取消',
        type: 'warning'
      }
    )
    .then(async () => {
      loading.value = true;
      try {
        const response = await requestV2.post(`/users/manage/${user.id}/toggle-status`, {
          status: newStatus
        });
        
        // 更新本地用户数据
        user.is_active = newStatus;
        
        ElMessage.success(response.data.message || `用户已${statusText}`);
      } catch (error) {
        console.error(`${statusText}用户失败:`, error);
        ElMessage.error(error.response?.data?.message || `${statusText}用户失败`);
      } finally {
        loading.value = false;
      }
    })
    .catch(() => {
      // 用户取消操作
    });
  } catch (error) {
    console.error(`${statusText}用户错误:`, error);
    ElMessage.error(`发生错误: ${error.message}`);
  }
};

// 查看登录历史
const viewLoginHistory = async (user) => {
  selectedUserId.value = user.id;
  loginHistoryDialogVisible.value = true;
};

// 显示批量导入对话框
const showBatchImportDialog = () => {
  batchImportDialogVisible.value = true;
  batchUsernames.value = '';
  importTabActive.value = 'manual';
  excelFileList.value = [];
  parsedExcelData.value = [];
};

// 下载Excel模板
const downloadTemplate = () => {
  // 创建一个简单的Excel模板
  const template = '用户名\nuser1\nuser2\nuser3'
  
  // 创建Blob并下载
  const blob = new Blob([template], { type: 'text/csv' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = '用户批量导入模板.csv'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
};

// Excel文件上传处理
const handleExcelChange = (file) => {
  const isExcel = file.raw.type === 'application/vnd.ms-excel' || 
                 file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                 /\.csv$/i.test(file.name);
  
  if (!isExcel) {
    ElMessage.error('请上传Excel文件(.xlsx, .xls)或CSV文件');
    excelFileList.value = [];
    return false;
  }
  
  // 读取Excel文件内容
  const reader = new FileReader();
  reader.onload = (e) => {
    try {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      
      // 获取第一个工作表
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      
      // 转换为JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
      
      // 过滤掉标题行和空行，只取第一列作为用户名
      parsedExcelData.value = jsonData
        .slice(1) // 跳过标题行
        .filter(row => row.length > 0 && row[0]) // 确保有数据且第一列不为空
        .map(row => row[0].toString().trim()) // 只取第一列作为用户名并转为字符串
        .filter(username => username); // 过滤掉空用户名
      
      if (parsedExcelData.value.length === 0) {
        ElMessage.warning('未找到有效的用户名数据，请检查Excel文件格式');
      }
    } catch (error) {
      console.error('解析Excel出错:', error);
      ElMessage.error('解析Excel文件失败，请检查文件格式');
      parsedExcelData.value = [];
    }
  };
  
  reader.readAsArrayBuffer(file.raw);
  return false; // 阻止自动上传
};

// 移除Excel文件
const handleExcelRemove = () => {
  excelFileList.value = [];
  parsedExcelData.value = [];
};

// 修改批量导入用户函数以支持Excel导入
const handleBatchImport = async () => {
  try {
    let usernameList = [];
    
    // 根据当前选择的导入方式获取用户名列表
    if (importTabActive.value === 'manual') {
      // 手动输入方式
      if (!batchUsernames.value.trim()) {
        ElMessage.warning('请输入用户名');
        return;
      }
      
      // 处理用户名列表，移除空行
      usernameList = batchUsernames.value
        .split('\n')
        .map(username => username.trim())
        .filter(username => username);
    } else {
      // Excel上传方式
      if (parsedExcelData.value.length === 0) {
        ElMessage.warning('请上传Excel文件并确保包含有效的用户名');
        return;
      }
      
      usernameList = parsedExcelData.value;
    }
    
    if (usernameList.length === 0) {
      ElMessage.warning('没有有效的用户名');
      return;
    }
    
    importLoading.value = true;
    
    // 调用批量导入API，使用request对象而不是fetch
    // 注意：request已经配置了baseURL为'/api'，所以这里不需要再加'/api'前缀
    const response = await request.post('/users/batch-import', {
      usernames: usernameList,
      defaultPassword: '666666'
    });
    
    const result = response.data;
    
    // 显示导入结果
    importResult.value = {
      total: result.total || usernameList.length,
      success: result.success || 0,
      failed: result.failed || 0,
      failedDetails: result.failedDetails || []
    };
    
    batchImportDialogVisible.value = false;
    importResultDialogVisible.value = true;
    
    // 如果有成功导入的用户，刷新用户列表
    if (result.success > 0) {
      await fetchUsers();
    }
    
  } catch (error) {
    console.error('批量导入用户失败:', error);
    ElMessage.error(error.response?.data?.message || '批量导入失败，请查看控制台了解详情');
  } finally {
    importLoading.value = false;
  }
};

// 导出用户列表
const exportUsers = async () => {
  try {
    ElMessage.info('正在导出用户数据，请稍候...')
    
    // 获取完整用户列表用于导出 - 使用axios的request对象
    const response = await request.get('/users/export', {
      responseType: 'blob' // 设置响应类型为blob
    });
    
    const blob = new Blob([response.data], { 
      type: response.headers['content-type'] 
    });
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = `用户列表_${new Date().toISOString().slice(0, 10)}.xlsx`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)
    
    ElMessage.success('用户数据导出成功')
  } catch (error) {
    console.error('导出用户失败:', error)
    ElMessage.error(error.response?.data?.message || '导出用户失败，请稍后再试')
  }
}
</script>

<style scoped>
.user-management-container {
  padding: 20px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-buttons {
  display: flex;
  gap: 10px;
}

.search-bar {
  margin-bottom: 20px;
}

.search-filter-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.form-tip {
  color: #909399;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.user-avatar {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
}

.avatar-uploader {
  width: 300px;
}

.platform-header {
  display: flex;
  align-items: center;
}

.platform-icon {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}

.no-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  background-color: #f5f7fa;
  font-size: 36px;
  color: #909399;
}

.operation-buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  justify-content: flex-start;
  min-width: 400px;
}

.operation-buttons .el-button {
  white-space: nowrap;
  padding-left: 12px;
  padding-right: 12px;
}

.admin-operation-notice {
  display: flex;
  justify-content: center;
  width: 100%;
}

/* 优化表格显示 */
:deep(.el-table .cell) {
  word-break: normal;
  white-space: nowrap;
}

.batch-import-textarea {
  margin: 15px 0;
}

.import-instructions {
  margin-bottom: 15px;
}

.import-example {
  margin-top: 10px;
}

.statistic-row {
  margin: 20px 0;
}

.result-summary {
  margin-bottom: 20px;
}

.failed-details {
  margin-top: 20px;
  border-top: 1px solid #ebeef5;
  padding-top: 20px;
}

.failed-details h4 {
  margin-bottom: 15px;
  color: #F56C6C;
}

.excel-uploader {
  margin: 20px 0;
}

.excel-preview-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #EBEEF5;
  padding: 15px;
  border-radius: 4px;
}

.excel-preview-container h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #606266;
}

.preview-count {
  margin-top: 10px;
  color: #909399;
  font-size: 14px;
  text-align: right;
}

.template-download {
  margin-top: 15px;
}
</style>